module.exports = __webpack_public_path__ + "static/wireframing-8693b8a68706d58d1bfcbed52af5794e.jpg";